import React from 'react';
import classNames from 'classnames';
import { useIntl } from 'react-intl';
import { Icon, TextInput } from '@doxyme/ui';
export function SeatsSelector({ value, onChange, min = 1, max = 9999, }) {
    const { formatMessage } = useIntl();
    const isMinusButtonDisabled = value <= min;
    const decreaseSeats = () => {
        if (value > min) {
            onChange(value - 1);
        }
    };
    const increaseSeats = () => {
        if (value < max) {
            onChange(value + 1);
        }
    };
    const handleInputChange = (e) => {
        const newValue = Number(e.target.value);
        if (!Number.isNaN(newValue) && newValue >= min && newValue <= max) {
            onChange(newValue);
        }
    };
    const decreaseLabel = formatMessage({ id: 'auth.payment-setup.seats-decrease' });
    const increaseLabel = formatMessage({ id: 'auth.payment-setup.seats-increase' });
    const seatsInputLabel = formatMessage({ id: 'auth.payment-setup.seats-input-label' });
    return (<div className="payment-setup__seats-widget-container">
      <label htmlFor="newSeatsNumber" className="payment-setup__visually-hidden">
        {seatsInputLabel}
      </label>

      <button className={classNames('payment-setup-minus-button', {
            'payment-setup-minus-button--disabled': isMinusButtonDisabled,
        })} type="button" disabled={isMinusButtonDisabled} onClick={decreaseSeats} aria-label={decreaseLabel}>
        <span className="payment-setup__visually-hidden">{decreaseLabel}</span>
        <div className={classNames('payment-setup__minus-icon', {
            'payment-setup__minus-icon--disabled': isMinusButtonDisabled,
        })} aria-hidden="true"/>
      </button>

      <TextInput id="newSeatsNumber" type="number" name="newSeatsNumber" className="payment-setup__seats-value-container" value={value} onChange={handleInputChange} aria-label={seatsInputLabel}/>

      <button className="payment-setup-plus-button" type="button" onClick={increaseSeats} aria-label={increaseLabel}>
        <span className="payment-setup__visually-hidden">{increaseLabel}</span>
        <Icon className="payment-setup__plus-icon" name="plus" aria-hidden="true"/>
      </button>
    </div>);
}
